<script setup lang="ts">
import CoverArtTile from '@/components/CoverArtTile.vue';

defineProps<{
  field: string;
  dataType: string;
  data: {
    cover_art_signed_url: string;
    cover_art: string;
    [key: string]: string;
  };
  isSelected?: boolean;
}>();
</script>

<template>
  <div class="flex items-center justify-center h-full py-1">
    <!-- Decorative in the grid: the track/album name is in an adjacent column and we now use
         real tooltips, so an empty alt avoids the browser's native advisory popup (and is the
         correct a11y treatment for a redundant thumbnail). -->
    <CoverArtTile
      :src="data.cover_art_signed_url || data.cover_art || null"
      alt=""
      :size="40"
      :preview-size="320"
      class="rounded-sm"
    />
  </div>
</template>
